import list from 'src/modules/keyword/list/keywordListReducers';
import form from 'src/modules/keyword/form/keywordFormReducers';
import view from 'src/modules/keyword/view/keywordViewReducers';
import destroy from 'src/modules/keyword/destroy/keywordDestroyReducers';
import importerReducer from 'src/modules/keyword/importer/keywordImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
